import React from 'react'
import * as R from 'ramda'

import styles from './Content.module.scss'
import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { QuestionPreview } from 'components/shared/QuestionPreview/QuestionPreview'

export const Content = ({ questions = [], title = '' }) => {
  const total = R.length(questions)

  return (
    <Box className={styles.content} direction="column" tagName="article">
      <h2 className={styles.title}>{title}</h2>
      <List className={styles.list} direction="column">
        {R.addIndex(R.map)(
          ({ description, id, title }) => (
            <QuestionPreview {...{ id, total, title, description }} key={id} />
          ),
          questions,
        )}
      </List>
    </Box>
  )
}
